import { createContext } from "react";
import { DrawerContextValue } from "./types";

export const DrawerContext = createContext<DrawerContextValue | undefined>(
  undefined,
);
